var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dhmap-wrapper"},[(!_vm.type)?_c('locator-point',{attrs:{"param":_vm.param,"mode":"h5"}}):_c('locator-report',{attrs:{"param":_vm.param,"mapData":_vm.mapData,"mode":"h5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }